// ============================================================================
// Debug Settings Utility
// ============================================================================
// Controls debug panel visibility - only admins can enable it
// ============================================================================

const DEBUG_KEY = 'crowdbuy_debug_enabled';
const ADMIN_KEY = 'crowdbuy_is_admin';
const NETWORK_KEY = 'crowdbuy_ton_network';

export type TonNetwork = 'mainnet' | 'testnet';

export function isDebugEnabled(): boolean {
  // Debug panel requires both admin status AND debug enabled
  const isAdmin = localStorage.getItem(ADMIN_KEY) === 'true';
  const debugEnabled = localStorage.getItem(DEBUG_KEY) === 'true';
  return isAdmin && debugEnabled;
}

export function setDebugEnabled(enabled: boolean): void {
  localStorage.setItem(DEBUG_KEY, enabled ? 'true' : 'false');
}

export function toggleDebug(): boolean {
  const current = localStorage.getItem(DEBUG_KEY) === 'true';
  setDebugEnabled(!current);
  return !current;
}

export function setAdminStatus(isAdmin: boolean): void {
  localStorage.setItem(ADMIN_KEY, isAdmin ? 'true' : 'false');
}

export function getAdminStatus(): boolean {
  return localStorage.getItem(ADMIN_KEY) === 'true';
}

export function getDebugToggleState(): { isAdmin: boolean; debugEnabled: boolean; network: TonNetwork } {
  return {
    isAdmin: getAdminStatus(),
    debugEnabled: localStorage.getItem(DEBUG_KEY) === 'true',
    network: getNetwork(),
  };
}

// TON Network selection
export function getNetwork(): TonNetwork {
  const stored = localStorage.getItem(NETWORK_KEY);
  return (stored === 'testnet' || stored === 'mainnet') ? stored : 'mainnet';
}

export function setNetwork(network: TonNetwork): void {
  localStorage.setItem(NETWORK_KEY, network);
}

export function isTestnet(): boolean {
  return getNetwork() === 'testnet';
}

// TON API endpoints
export const TON_ENDPOINTS = {
  mainnet: 'https://toncenter.com/api/v2',
  testnet: 'https://testnet.toncenter.com/api/v2',
} as const;

export function getTonEndpoint(): string {
  return TON_ENDPOINTS[getNetwork()];
}